import React, { FC, RefObject, Suspense } from 'react';
import { lazy } from '@funtech-int/rival-react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

interface Props {
    rootContainerRef: RefObject<HTMLDivElement>;
}

const ContextMenu = lazy(
    () => import('@/scenarios/legacy-player/components/PlayerSkin/parts/ContextMenu/ContextMenu')
);

export const ContextMenuContainer: FC<Props> = ({ rootContainerRef }) => {
    const instance = usePlayerInstance();

    return (
        <Suspense fallback={null}>
            <ContextMenu
                targetRef={rootContainerRef}
                otherPopupVisible={false}
                requestDebugInfo={instance?.requestDebugInfo?.bind(instance)}
                vsid={instance?.vsid}
            />
        </Suspense>
    );
};
